import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { EmployeeBox, GapBox } from 'components/Box'
import { BoxForm, Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { PubAdsServiceRefreshInput } from '../../components/PubAdsServiceRefreshInput'
import { EditSchema } from '../../schemas/editSchema'

export const AdvancedSettings = (): React.JSX.Element => {
  const ability = useAbility()
  const { t } = useTranslation(['features/domain', 'common'])
  const { control } = useFormContext<EditSchema>()

  const canReadDomainOverriddenByYieldbird: boolean = ability.can(
    'read',
    'DomainField-overriddenByYieldbird',
  )
  const cannotUpdateDomainOverriddenByYieldbird: boolean = ability.cannot(
    'update',
    'DomainField-overriddenByYieldbird',
  )

  return (
    <Paper>
      <SectionHeader
        subtitle={t('form.general.advancedSettings.subtitle')}
        title={t('form.general.advancedSettings.title')}
      />

      <GapBox />

      <BoxForm>
        <PubAdsServiceRefreshInput />

        {canReadDomainOverriddenByYieldbird && (
          <EmployeeBox>
            <Switch
              control={control}
              disabled={cannotUpdateDomainOverriddenByYieldbird}
              label={t('form.general.advancedSettings.overriddenByYieldbird.label')}
              labelPlacement='start'
              name='overriddenByYieldbird'
            />
          </EmployeeBox>
        )}
      </BoxForm>
    </Paper>
  )
}
